/**
 * Picker API client (P3-A) — universal entity dropdown source.
 *
 * Backend: GET /api/v1/picker/{kind}?q=&parent_id=&filters=&limit=
 * Doc 36 §3.2.
 */
import { api } from "./client";

export type PickerKind =
  | "form"
  | "workflow"
  | "notification_template"
  | "notification_channel"
  | "notification_rule"
  | "custom_field"
  | "odoo_user"
  | "odoo_model"
  | "odoo_field"
  | "external_system";

export interface PickerItem {
  id: string;
  label: string;
  secondary?: string | null;
  icon?: string | null;
  tags?: string[];
}

export interface PickerResponse {
  items: PickerItem[];
  has_more: boolean;
}

export interface PickerOptions {
  q?: string;
  parentId?: string;
  filters?: Record<string, unknown>;
  limit?: number;
}

export const pickerApi = {
  search: (kind: PickerKind, options: PickerOptions = {}): Promise<PickerResponse> => {
    const query: Record<string, string | number> = {};
    if (options.q) query.q = options.q;
    if (options.parentId) query.parent_id = options.parentId;
    if (options.filters) query.filters = JSON.stringify(options.filters);
    if (options.limit) query.limit = options.limit;
    return api.get<PickerResponse>(`/api/v1/admin/picker/${kind}`, { query });
  },
};
